import React, { useState, useEffect } from 'react';
import '../../css/Pages.css';
import CountryListing from '../../components/CategoryManagement/Country/CountryListing';
import { useCountries } from '../../hooks/useCountries';

const Country = () => {
    const { countries, isLoading, fetchError, refetch } = useCountries();

    const [filteredCountries, setFilteredCountries] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [isDesktop, setIsDesktop] = useState(true);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth > 992);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setFilteredCountries(countries);
    }, [countries]);

    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);

        const filtered = countries.filter(country =>
            (country.nameVi && country.nameVi.toLowerCase().includes(query)) ||
            (country.nameEn && country.nameEn.toLowerCase().includes(query)) ||
            (country.id && country.id.toLowerCase().includes(query))
        );
        setFilteredCountries(filtered);
    };

    return (
        <div className="page-container">
            <div className="page-header" style={{ marginBottom: '10px' }}>
                <div className="header-title">
                    <h2>DANH MỤC QUỐC GIA</h2>
                </div>
            </div>

            <div style={isDesktop
                ? { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }
                : { display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '20px' }
            }>
                <p className="sub-title" style={{ margin: 0 }}>DANH MỤC QUỐC GIA</p>

                <div style={isDesktop
                    ? { display: 'flex', gap: '10px' }
                    : { display: 'flex', gap: '10px', width: '100%', alignItems: 'stretch' }
                }>
                    <div style={isDesktop ? {} : { flex: 1 }}>
                        <input
                            type="text"
                            placeholder="Tìm theo tên hoặc mã quốc gia"
                            className="form-input"
                            style={isDesktop
                                ? { width: '300px', padding: '8px 15px' }
                                : { width: '100%', padding: '8px 15px', boxSizing: 'border-box', height: '100%' }
                            }
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                    </div>
                    <button
                        onClick={refetch}
                        className="btn-add-new"
                        style={isDesktop
                            ? { margin: 0, padding: '8px 15px', backgroundColor: '#6c757d' }
                            : { margin: 0, padding: '0', width: '45px', flex: '0 0 45px', backgroundColor: '#6c757d', display: 'flex', justifyContent: 'center', alignItems: 'center' }
                        }
                        title="Tải lại dữ liệu"
                    >
                        <i className="fa-solid fa-rotate-right"></i>
                    </button>
                </div>
            </div>

            {fetchError && (
                <div style={{ backgroundColor: '#f8d7da', color: '#721c24', padding: '15px', borderRadius: '4px', marginBottom: '20px', border: '1px solid #f5c6cb' }}>
                    <i className="fa-solid fa-triangle-exclamation" style={{ marginRight: '8px' }}></i>
                    <strong>Lỗi kết nối:</strong> Không thể lấy dữ liệu từ máy chủ quốc tế. Trình duyệt hoặc mạng của bạn (Firewall/VPN) có thể đang chặn đường dẫn API
                </div>
            )}

            <CountryListing
                data={filteredCountries}
                isLoading={isLoading}
                searchQuery={searchQuery}
                fetchError={fetchError}
            />
        </div>
    );
};

export default Country;